import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Download, Shield } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-navy text-white py-16 md:py-24" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-150">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-151">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gold mb-6 leading-tight" data-id="element-152">
              Renueva tu mente, ordena tu vida y camina en paz con Dios.
            </h1>

            <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed" data-id="element-153">
              Un plan de 30 días para salir del desorden mental, la ansiedad por
              el dinero y el estancamiento — con fe práctica, hábitos simples y
              la guía de Dios.
            </p>

            <div className="space-y-3 mb-8" data-id="element-154">
              <div className="flex items-start gap-3" data-id="element-155">
                <span className="text-gold text-xl" data-id="element-156">✅</span>
                <p className="text-white/90" data-id="element-157">
                  Calma la ansiedad y el "ruido" mental con herramientas de fe y
                  acción diaria
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-158">
                <span className="text-gold text-xl" data-id="element-159">✅</span>
                <p className="text-white/90" data-id="element-160">
                  Fortalece tu relación con Dios y tu capacidad de recibir
                  provisión con paz
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-161">
                <span className="text-gold text-xl" data-id="element-162">✅</span>
                <p className="text-white/90" data-id="element-163">
                  Crea hábitos concretos de oración, gratitud y obediencia en
                  solo 10–15 min/día
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-164">
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg" data-id="element-165">
                <Calendar className="w-6 h-6 text-gold mb-2" data-id="element-166" />
                <span className="text-sm font-medium" data-id="element-167">30 días</span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg" data-id="element-168">
                <Clock className="w-6 h-6 text-gold mb-2" data-id="element-169" />
                <span className="text-sm font-medium" data-id="element-170">10–15 min/día</span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg" data-id="element-171">
                <Download className="w-6 h-6 text-gold mb-2" data-id="element-172" />
                <span className="text-sm font-medium" data-id="element-173">Descarga inmediata</span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg" data-id="element-174">
                <Shield className="w-6 h-6 text-gold mb-2" data-id="element-175" />
                <span className="text-sm font-medium" data-id="element-176">Garantía 7 días</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-177">
              <motion.a href="#closing" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="bg-gold text-dark font-semibold px-8 py-4 rounded-lg text-lg shadow-lg hover:brightness-110 transition-all inline-block" data-id="element-178">
                Quiero empezar hoy — $12.00
              </motion.a>
              <a href="#includes" className="text-white border-2 border-white/30 font-semibold px-8 py-4 rounded-lg text-lg hover:bg-white/10 transition-all text-center" data-id="element-179">
                Ver qué incluye ↓
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center" data-id="element-180">
            <img src="https://cdn.magicpatterns.com/uploads/5pKAovLkT29Uy4GJEkTQ8R/heylloyd-image-1775363601783.png" alt="30 Días con Dios - Orden, Provisión y Abundancia" className="rounded-lg shadow-2xl max-w-md w-full" data-id="element-181" />
          </motion.div>
        </div>
      </div>
    </section>;
}